import { useTexture } from "@react-three/drei"
import * as THREE from "three";
export default function Pavement({Size}){

    const texture = useTexture("./Textures/Pavement.jpg");
    texture.wrapS = texture.wrapT = THREE.RepeatWrapping;
    texture.repeat.set( Size[0]/4, Size[1]/4);
    
    
    return(
        <>
        <mesh rotation={[-Math.PI / 2,0,0]} position={[0,0.01,0]} scale={[1,1,1]} castShadow receiveShadow >
            <planeGeometry args={Size} />
            <meshStandardMaterial color="#ffffff" map={texture} />
        </mesh>
        </>
    )
}